import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let heroTl = gsap
  .timeline({ defaults: { duration: 2, ease: "power2.out" }, paused: true })
  .addLabel("start")
  .from("header h1", {
    autoAlpha: 0,
    y: "-1.5rem",
  })
  .from(
    "header ul li",
    {
      autoAlpha: 0,
      y: "-1.5rem",
      stagger: 0.1,
      clearProps: "transform,visibility,opacity",
    },
    "<0.2"
  )

  .from(
    "#home h2, #home h3",
    {
      autoAlpha: 0,
      y: "3rem",
      stagger: 0.1,
    },
    "start"
  );

$(window).on("load resize", function () {
  let headerHeight = $("header").outerHeight();
  $("#home").css("margin-top", `${headerHeight}px`);
  $("#home").css("height", `${$(window).innerHeight() - headerHeight}px`);
});

ScrollTrigger.batch(".fade-in-up", {
  batchMax: 20,
  once: true,
  onEnter: (batch) => {
    gsap.to(batch, {
      autoAlpha: 1,
      y: "0",
      stagger: 0.25,
      duration: 1,
      delay: 0.25,
    });
  },
});

ScrollTrigger.batch(".fade-in", {
  batchMax: 20,
  once: true,
  onEnter: (batch) => {
    gsap.to(batch, {
      autoAlpha: 1,
      stagger: 0.25,
      duration: 1,
      delay: 0.25,
    });
  },
});

$(window).on("load", function () {
  $(".load-overlay").fadeOut(150);
  heroTl.play();
});
